import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

export interface Product {
  pic: string; 
  info1: string;
  info2: string;
  info3: string;
  info4: string;
}

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  public dataSize;
  public nbPages;
  public offerPerPage = 1;
  public currentPage;
  public productsPage: Product[] = [];

  //DataBase Front
  public products: Product[] = [
     {
       info1: "High Resolution 4K/6MP/4MP 1080P - high image quality - 4 signals Video/Audio/Data/Power over one cable", 
       info2: "Superior Image Starlight - Ultra 140dB WDR provides clear - image under extreme - light conditions", 
       info3: "Wide Selection - Multi lens and fisheye - cameras can replace multiple cameras - saving on costs", 
       info4: " Long distance - Coaxial Cable: Up to 1200m - UTP: Up to 450m", 
       pic: "HD CAM"
      },
     {
       info1: "Advanced Sensors - High performance Sony - height sensors delievery - quality and reliability", 
       info2: "Superior Image - Starlight / 120db WDR - provides clear image under any light conditions", 
       info3: "Super IR Range - Cameras provide up to 200m IR range - performance in dark environments", 
       info4: "Powerful Protection - IP67 / IK10 ratings ensures - ability to withstand - tough conditions", 
       pic:"HD PTZ CAM"
    },
     {
       info1: "H.265+/H.265 - overall system cost. H.265+/H.265 - Improves encoding efficiency - reducing overall system cost", 
       info2: "High Definition Up to 4K resolution available - All-over-Coax Coaxial audio/alarm/firmware upgrade", 
       info3: "Super Performance - Supports N+N channels - IPC access, each channel - up to 8MP input", 
       info4: "Cost/Performance - Advanced processors - provide good image quality and color optimisation - cost effectiveness", 
       pic:"HD RECORDERS"
      },
     {
       info1: "Supports HDCVI/AHD/TVI/IP video inputs", 
       info2: "Supports high quality 2-way audio", 
       info3: "Built-in 2.4G/5G Wi-Fi module and 4G", 
       info4: "Supports max. 128GB SD", 
       pic:"NETWORK VIDEO SERVERS"
      },
     {
       info1: "High/Performance - Super-sensitive Sony STARVIS™ sensor for unparalleled performance - Starlight / Ultra 140dB WDR provides clear image under any light conditions", 
       info2: "People Counting - heat map - and SSA to greatly increase efficiency - Sensor Integration, eyes All Around - Optimized Image quality - Highly Flexible", 
       info3: "Advanced encoding - saves up to 50% bandwidth and storage - Migration Analog to IP with Ethernet-tocoax converter and PoC", 
       info4: "POE Up to 800m transmission distance @10Mbps/13W or 300m @100Mbps/25.4W", 
       pic:"NETWORK CAM"
      },
     {
       info1: "Advanced Sensors - High sensitivity & low noise with backilluminated pixel - Powerful Zoom 25x / 30x / 40x / 48x - optical zoom easily covers large areas", 
       info2: "Provide up to 550m IR range in dark environments - Improved focusing performance - Powerful Zoom 30x/40x/45x/48x - optical zoom covers large areas - auto tracking Surveillance", 
       info3: "Superior Image Starlight - Ultra 140dB WDR provides clear image under any light conditions", 
       info4: "PTZ tracks suspicious objects - Powerful Protection IP67 / IK10 ratings ensures cameras can withstand tough conditions", 
       pic:"NETWORK PTZ CAM"
      },
     {
       info1: "CPU provides hight performance processing - High quality redundant - enabled design ensures high reliability and data safety", 
       info2: "ARM Cortex 4K processor features enhanced power - saving capabilities - Full range of high, middle, and entry-level products", 
       info3: "Fisheye dewarp, POS, ANPR (optional), N+M fail-over", 
       info4: "Face Detection ensure efficient surveillance", 
       pic:"NETWORK VIDEO RECORDERS"
      }
  ];


  constructor() { }

  ngOnInit() {
    this.dataSize = this.products.length;
    this.nbPages = Math.ceil(this.dataSize / this.offerPerPage);
    this.productsPage = this.products.slice(0, this.offerPerPage);
    this.currentPage = 1;
    //put the page name in the beard div of the navbar
    var beard = $(".beard");
    beard.text("Items");
  }

  public displayDataPage(page: number) {
     if(page<=0)
      page++;
    else if(page>this.nbPages)
      page--;

    this.currentPage = page;

    switch (page) {
      case 1: //first page
        this.productsPage = this.products.slice(0, this.offerPerPage);
        break;
      case this.nbPages: //last page
        this.productsPage = this.products.slice(this.nbPages*this.offerPerPage-this.offerPerPage, this.nbPages*this.offerPerPage);
        break;
      default: // pages in between
        this.productsPage = this.products.slice(page*this.offerPerPage-this.offerPerPage, page*this.offerPerPage);
        break;
    }

    $("div.contents").scrollTop(10);
}


}



// WEBPACK FOOTER //
// ./src/app/components/products/products.component.ts